import React from 'react';
import { Helmet } from 'react-helmet-async';

import Skills from '../Skills/Skills';

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Slávka Vavřinová | Frontend Developer & Coach</title>
        <meta
          name="description"
          content="Slávka Vavřinová – full-stack software developer, Czechitas coach a UX designérka. Podívejte se na mé projekty a zkušenosti."
        />
        <link rel="canonical" href="https://www.slavkavav.cz/" />
      </Helmet>
      <div className="main">
        <p>
          Hi, I'm <strong>Slávka</strong>
        </p>
        <p>
          <strong>Full-stack Software Developer</strong>
        </p>

        <p>
          I actually stumbled into programming by accident. It all started when
          I received a scholarship for the Digital Academy: Web. My original
          goal was humble: I just wanted to fix my parents' website. But from
          the very first line of code, I was hooked. I knew right then that this
          wasn't just a hobby—it was the career I wanted to pursue. (You can
          listen to more about my journey in{' '}
          <a href="https://www.czechitas.cz/blog/slavka-vavrinova-od-uveru-k-programovacim-jazykum-podcast">
            this podcast
          </a>
          .)
        </p>

        <p>
          In 2022, I joined <strong>Robert Bosch České Budějovice</strong> as a
          developer. Looking back, I’ll admit the beginning was tough.
          Surrounded by experts, I quickly realized how much I still had to
          learn! But I grit my teeth, put in long hours at the computer, and
          pushed through. If you're reading this and feeling like you're in over
          your head: keep going. It might be a struggle at first, but if you
          stay focused on your goal, you will get there.
        </p>

        <p>
          Currently, I’m a <strong>Mid-level developer</strong> on our team
          (with my sights set on Senior very soon! 😉). While my core role is in
          Backend (PHP/Nette), I’ve managed to "sneak" React into my workflow. I
          have a deep passion for the frontend, and since 2025, I’ve taken
          charge of UX/UI within our department. I now help my colleagues
          elevate their projects through Figma prototyping and insights gained
          from specialized UX training.
        </p>

        <p>
          I thrive on learning new things—a must in the ever-evolving world of
          tech. What drives me is the sheer variety of my work:
        </p>
        <ul>
          <li>Developing applications used globally.</li>
          <li>Influencing app architecture.</li>
          <li>Designing intuitive user interfaces.</li>
        </ul>

        <p>
          I also draw on my previous experience in banking when communicating
          with clients, ensuring that the technical solutions and features I
          deliver align perfectly with business needs.
        </p>

        <p>
          I work in an international environment where I use English every day,
          both for programming and in business communications. I also speak
          German.
        </p>

        <p>
          I spend my free time with my family and enjoy sports activities —
          Alpinning, Jumping, running, or skiing.
        </p>
        <Skills />
      </div>
    </>
  );
};

export default Home;
